import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../../contexts/TranslationContext';
import '../../styles/legal.scss';

const CONTACT_EMAIL = 'privacy@philipsnat.com';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  const lp = t.legal.privacy;

  return (
    <div className="legal-page">
      <Helmet>
        <title>Privacy Policy | PhilipSnat</title>
        <meta name="description" content="Read the PhilipSnat Privacy Policy to learn how we collect, use, and protect your personal data." />
        <link rel="canonical" href="https://philipsnat.com/privacy-policy" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="legal-page__container">
        <div className="legal-page__header">
          <h1 className="legal-page__title">{lp.title}</h1>
          <p className="legal-page__updated">{t.legal.lastUpdated.replace('{date}', 'May 4, 2026')}</p>
        </div>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s1Title}</h2>
          <p className="legal-page__text">{lp.s1Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s2Title}</h2>
          <p className="legal-page__text">{lp.s2Intro}</p>
          <ul className="legal-page__list">
            <li>{lp.s2Email}</li>
            <li>{lp.s2FullName}</li>
            <li>{lp.s2Birthdate}</li>
            <li>{lp.s2Country}</li>
          </ul>
          <p className="legal-page__text">{lp.s2Outro}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s3Title}</h2>
          <p className="legal-page__text">{lp.s3Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s4Title}</h2>
          <p className="legal-page__text">{lp.s4Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s5Title}</h2>
          <p className="legal-page__text">{lp.s5Intro}</p>
          <ul className="legal-page__list">
            <li>{lp.s5Access}</li>
            <li>{lp.s5Erasure}</li>
            <li>{lp.s5Portability}</li>
            <li>{lp.s5Rectification}</li>
            <li>{lp.s5Object}</li>
          </ul>
          <p className="legal-page__text">{lp.s5Outro}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s6Title}</h2>
          <div className="legal-page__highlight">
            <p className="legal-page__text">
              {lp.s6Text}{' '}
              <a className="legal-page__link" href={`mailto:${CONTACT_EMAIL}`}>
                {CONTACT_EMAIL}
              </a>
            </p>
          </div>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s7Title}</h2>
          <p className="legal-page__text">{lp.s7Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s8Title}</h2>
          <p className="legal-page__text">{lp.s8Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s9Title}</h2>
          <p className="legal-page__text">{lp.s9Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lp.s10Title}</h2>
          <p className="legal-page__text">{lp.s10Text}</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
